import { Vec3 } from "pixi3d/pixi7";
import { DiceResult } from "../models/DiceResult";

export class DiceDirectionDescription {
    private static readonly diceResultToTransformDirection: Map<DiceResult, Float32Array> = new Map([
        [DiceResult.Crown, Vec3.fromValues(0, 1, 0)],
        [DiceResult.Mask, Vec3.fromValues(0, 0, -1)],
        [DiceResult.Jail, Vec3.fromValues(0, -1, 0)],
        [DiceResult.Aim, Vec3.fromValues(1, 0, 0)],
        [DiceResult.House, Vec3.fromValues(0, 0, 1)],
        [DiceResult.Mystery, Vec3.fromValues(-1, 0, 0)]
    ]);

    public static diceResultToBodyDirection(result: DiceResult): Float32Array {
        return DiceDirectionDescription.diceResultToTransformDirection.get(result);
    }
}
